(function () {
  'use strict';
  if (window.__STPickupTimeNoticeInstalled) return;
  window.__STPickupTimeNoticeInstalled = true;

  var NOTE_CLASS = 'st-pickup-time-estimate-notice';
  var TIME = /^(?:(?:0?[1-9]|1[0-2]):[0-5]\d\s*(?:a\.?m\.?|p\.?m\.?)|(?:0?[1-9]|1[0-2])\s*(?:a\.?m\.?|p\.?m\.?)|(?:[01]?\d|2[0-3]):[0-5]\d)$/i;
  var queued = false;

  function clean(s) { return String(s || '').replace(/\s+/g, ' ').trim().replace(/[▾▼⌄⌃]+$/, '').trim(); }
  function isTime(s) { return TIME.test(clean(s)); }

  function isVisible(el) {
    if (!el || !el.isConnected || !el.getClientRects().length) return false;
    if (el.closest('[hidden],[aria-hidden="true"],.' + NOTE_CLASS)) return false;
    var st = window.getComputedStyle(el);
    return st.display !== 'none' && st.visibility !== 'hidden';
  }

  function selectedTimeIsVisible(panel) {
    // Use what the customer can actually see in the pickup widget, never stale cart attributes.
    var controls = panel.querySelectorAll('select,input:not([type="hidden"]),button,[role="combobox"],[aria-selected="true"],[aria-valuetext]');
    for (var i = 0; i < controls.length; i++) {
      var el = controls[i];
      if (!isVisible(el)) continue;
      if (el.tagName === 'SELECT') {
        var opt = el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null;
        if (isTime(el.value) || (opt && isTime(opt.textContent))) return true;
      } else if (isTime(el.value) || isTime(el.getAttribute('aria-valuetext')) || isTime(el.getAttribute('aria-label')) || isTime(el.textContent)) {
        return true;
      }
    }

    // Some pickup apps render the selected time as plain text in a styled dropdown.
    // Look only inside the pickup app / cart summary, never in the list of ordered items.
    var nodes = panel.querySelectorAll('span,div,p,strong');
    for (var j = 0; j < nodes.length; j++) {
      var n = nodes[j];
      if (!isVisible(n) || !isTime(n.textContent)) continue;
      var parent = n.closest('button,[role="combobox"],[aria-selected="true"],[class*="time" i],[id*="time" i],[class*="select" i],[class*="slot" i]');
      if (parent && isVisible(parent)) return true;
      // The pickup app may use unlabelled divs for the selected value.
      var host = n.closest('#storePickupApp');
      if (host && isVisible(host) && n.children.length === 0) return true;
    }
    return false;
  }

  function ensureNote(host) {
    var note = host.nextElementSibling;
    if (note && note.classList.contains(NOTE_CLASS)) return note;
    note = document.createElement('p');
    note.className = NOTE_CLASS;
    note.setAttribute('role', 'note');
    note.setAttribute('aria-live', 'polite');
    note.style.cssText = 'display:none;margin:10px 0 14px;padding:10px 12px;border-left:3px solid #56aab3;background:#f5faf8;color:#443c36;border-radius:4px;font-size:13px;line-height:1.5;';
    var title = document.createElement('strong');
    title.textContent = 'Pickup Time Notice';
    note.appendChild(title);
    note.appendChild(document.createTextNode(' Pickup times are estimates and may vary depending on orders ahead of yours and preparation time. If you need your order ready by a specific time, please call the shop after placing your order so we can prioritize and accommodate your request.'));
    host.insertAdjacentElement('afterend', note);
    return note;
  }

  function refresh() {
    var hosts = document.querySelectorAll('#storePickupApp');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i];
      var panel = host.closest('#AjaxCartSubtotal,.cart__details') || host.parentElement;
      if (!panel) continue;
      var note = ensureNote(host);
      var show = selectedTimeIsVisible(panel);
      var display = show ? 'block' : 'none';
      if (note.style.display !== display) note.style.display = display;
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.setTimeout(function () { queued = false; refresh(); }, 120);
  }

  function start() {
    refresh();
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', schedule, true);
    document.addEventListener('keyup', schedule, true);
    document.addEventListener('shopify:section:load', schedule);
    window.addEventListener('pageshow', schedule);
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target && (m.target.nodeType === 1 ? m.target : m.target.parentElement);
        if (target && target.closest && target.closest('.' + NOTE_CLASS)) continue;
        if (target && target.closest && target.closest('#AjaxCartSubtotal,#storePickupApp')) {
          schedule(); return;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1 && (n.id === 'storePickupApp' || n.id === 'AjaxCartSubtotal' || (n.querySelector && n.querySelector('#storePickupApp')))) {
            schedule(); return;
          }
        }
      }
    }).observe(document.body, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['value','aria-selected','aria-valuetext','checked']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();